import { render, staticRenderFns } from "./NotPreviewContentComponent.vue?vue&type=template&id=115e4fa6&scoped=true"
import script from "./NotPreviewContentComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotPreviewContentComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotPreviewContentComponent.vue?vue&type=style&index=0&id=115e4fa6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e4fa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115e4fa6')) {
      api.createRecord('115e4fa6', component.options)
    } else {
      api.reload('115e4fa6', component.options)
    }
    module.hot.accept("./NotPreviewContentComponent.vue?vue&type=template&id=115e4fa6&scoped=true", function () {
      api.rerender('115e4fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/components/NotPreviewContentComponent.vue"
export default component.exports